module.exports = __webpack_public_path__ + "img/9791190422246.14941c10.jpg";